module.exports = __webpack_public_path__ + "img/Bonehead.bda5b8c9.png";